import { isEnabled } from "utils/featureFlags";

const UPDATE_FIELD = "pagination/UPDATE_FIELD";
const RESET_PAGINATION = "pagination/RESET_PAGINATION";

const initialState = {
  datasets: null,
  runs: null,
  projects: null,
  reports: null,
  // This gets reset during fetchall in accounts
  hideShowMoreDatasets: false
};

export default function paginationReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    case RESET_PAGINATION:
      return { ...initialState };
    default:
      return state;
  }
}

/* Selectors */
export function getPagination(state) {
  return state.pagination;
}

export function getDatasetsPage(state) {
  return getPagination(state).datasets;
}

export function getProjectsPage(state) {
  return getPagination(state).projects;
}

export function getRunsPage(state) {
  return getPagination(state).runs;
}

export function getReportsPage(state) {
  return getPagination(state).reports;
}

export function getHideShowMoreDatasets(state) {
  return getPagination(state).hideShowMoreDatasets;
}

/* Actions */
export function resetPagination() {
  return { type: RESET_PAGINATION };
}

export function updateProjectsPage(latestProject) {
  return { type: UPDATE_FIELD, data: latestProject, key: "projects" };
}

export function updateDatasetsPage(latestDataset) {
  return { type: UPDATE_FIELD, data: latestDataset, key: "datasets" };
}

export function updateRunsPage(latestRun) {
  return { type: UPDATE_FIELD, data: latestRun, key: "runs" };
}

export function updateReportsPage(latestReport) {
  return { type: UPDATE_FIELD, data: latestReport, key: "reports" };
}

export function updateHideShowMoreDatasets(val) {
  return { type: UPDATE_FIELD, data: val, key: "hideShowMoreDatasets" };
}

/* Methods */
export function getLatestId(data, isMax = false) {
  const minId = data.reduce((accumulator, currData) => {
    const currId = currData.id;
    if (accumulator === null) {
      return currId;
    }
    return isMax ? Math.max(accumulator, currId) : Math.min(accumulator, currId);
  }, null);
  return minId;
}

export function storeLatestProject(data) {
  return (dispatch, getState) => {
    const minId = getLatestId(data);
    if (minId) {
      dispatch(updateProjectsPage(minId));
    }
  };
}

export function storeLatestDataset(data) {
  return (dispatch, getState) => {
    const minId = getLatestId(data);
    if (minId) {
      dispatch(updateDatasetsPage(minId));
    }
  };
}

export function storeLatestRun(data) {
  return (dispatch, getState) => {
    const minId = getLatestId(data);
    if (minId) {
      dispatch(updateRunsPage(minId));
    }
  };
}

export function storeLatestReport(data) {
  return (dispatch, getState) => {
    const minId = getLatestId(data);
    if (minId) {
      dispatch(updateReportsPage(minId));
    }
  };
}
